import React from 'react';
import styles from './RichText.module.less';

const RichText = ({
  element,
}) => {
  function createMarkup() {
    return {__html: element.value};
  }
  return (
    <section
      className={styles.vpRichText}
      dangerouslySetInnerHTML={createMarkup()}
    />
  );
}

RichText.propTypes = {};

export default RichText;



// WEBPACK FOOTER //
// ./src/components/CampaignSuccess/RichTextLandingPageElement.jsx